// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: "icon";
	font-display: block;
	src: url("https://static.club.hotmart.com/admin/beta/fonts/icon.52890268f0375f7bd49ed6145a31fb1a.eot?#iefix") format("embedded-opentype"),
url("https://static.club.hotmart.com/admin/beta/fonts/icon.72d402e7d174df603e21770726d748f5.woff") format("woff"),
url("https://static.club.hotmart.com/admin/beta/fonts/icon.9009ded4b3d242c828d28efc5e39acb2.woff2") format("woff2"),
url("https://static.club.hotmart.com/admin/beta/fonts/icon.5a4def8981013a949ab33e709dd1ecf5.ttf") format("truetype"),
url("https://static.club.hotmart.com/admin/beta/fonts/icon.e687e3b49a1a9d8610127dedfeefd686.svg#icon") format("svg");
}

#ClubAdminApp .icon {
	line-height: 1;
}

#ClubAdminApp .icon:before {
	font-family: icon !important;
	font-style: normal;
	font-weight: normal !important;
	vertical-align: top;
}

.icon-add-content:before {
	content: "\\f101";
}
.icon-add-quiz:before {
	content: "\\f102";
}
.icon-add-text:before {
	content: "\\f103";
}
.icon-add-upsell:before {
	content: "\\f104";
}
.icon-add:before {
	content: "\\f105";
}
.icon-alarm:before {
	content: "\\f106";
}
.icon-align-center:before {
	content: "\\f107";
}
.icon-align-justify:before {
	content: "\\f108";
}
.icon-align-left:before {
	content: "\\f109";
}
.icon-align-right:before {
	content: "\\f10a";
}
.icon-align:before {
	content: "\\f10b";
}
.icon-arrow-down:before {
	content: "\\f10c";
}
.icon-arrow-forward:before {
	content: "\\f10d";
}
.icon-arrow-left:before {
	content: "\\f10e";
}
.icon-arrow-link:before {
	content: "\\f10f";
}
.icon-arrow-path:before {
	content: "\\f110";
}
.icon-arrow-right:before {
	content: "\\f111";
}
.icon-arrow-up-down:before {
	content: "\\f112";
}
.icon-arrow-up-right:before {
	content: "\\f113";
}
.icon-arrow-up:before {
	content: "\\f114";
}
.icon-ask-icon:before {
	content: "\\f115";
}
.icon-back:before {
	content: "\\f116";
}
.icon-badge-dollar-lg:before {
	content: "\\f117";
}
.icon-badge-dollar:before {
	content: "\\f118";
}
.icon-bell-cosmos:before {
	content: "\\f119";
}
.icon-bell-lg:before {
	content: "\\f11a";
}
.icon-bell-md:before {
	content: "\\f11b";
}
.icon-bell:before {
	content: "\\f11c";
}
.icon-bold:before {
	content: "\\f11d";
}
.icon-calendar-plus:before {
	content: "\\f11e";
}
.icon-calendar:before {
	content: "\\f11f";
}
.icon-camera:before {
	content: "\\f120";
}
.icon-change:before {
	content: "\\f121";
}
.icon-chart:before {
	content: "\\f122";
}
.icon-chat:before {
	content: "\\f123";
}
.icon-check-cosmos:before {
	content: "\\f124";
}
.icon-check-green-cosmos:before {
	content: "\\f125";
}
.icon-check-green:before {
	content: "\\f126";
}
.icon-check-normal:before {
	content: "\\f127";
}
.icon-check-red-big:before {
	content: "\\f128";
}
.icon-check:before {
	content: "\\f129";
}
.icon-checkbox-check:before {
	content: "\\f12a";
}
.icon-chevron-down:before {
	content: "\\f12b";
}
.icon-chevron-up:before {
	content: "\\f12c";
}
.icon-class-arrow:before {
	content: "\\f12d";
}
.icon-class:before {
	content: "\\f12e";
}
.icon-classes:before {
	content: "\\f12f";
}
.icon-close-arrow:before {
	content: "\\f130";
}
.icon-close-circle:before {
	content: "\\f131";
}
.icon-close-cosmos:before {
	content: "\\f132";
}
.icon-close:before {
	content: "\\f133";
}
.icon-collapse-all-lg:before {
	content: "\\f134";
}
.icon-collapse-all:before {
	content: "\\f135";
}
.icon-color-picker:before {
	content: "\\f136";
}
.icon-combined-shape-back:before {
	content: "\\f137";
}
.icon-combined-shape-front:before {
	content: "\\f138";
}
.icon-combined-shape:before {
	content: "\\f139";
}
.icon-comments-inverted:before {
	content: "\\f13a";
}
.icon-comments:before {
	content: "\\f13b";
}
.icon-communicate:before {
	content: "\\f13c";
}
.icon-community-menu:before {
	content: "\\f13d";
}
.icon-community:before {
	content: "\\f13e";
}
.icon-configs:before {
	content: "\\f13f";
}
.icon-configuration:before {
	content: "\\f140";
}
.icon-content-list-empty-image:before {
	content: "\\f141";
}
.icon-content-menu:before {
	content: "\\f142";
}
.icon-content:before {
	content: "\\f143";
}
.icon-delete-lg:before {
	content: "\\f144";
}
.icon-delete:before {
	content: "\\f145";
}
.icon-down-chevron:before {
	content: "\\f146";
}
.icon-download:before {
	content: "\\f147";
}
.icon-duplicate-cosmos:before {
	content: "\\f148";
}
.icon-duplicate-lg:before {
	content: "\\f149";
}
.icon-duplicate-sm:before {
	content: "\\f14a";
}
.icon-duplicate:before {
	content: "\\f14b";
}
.icon-edit-cosmos:before {
	content: "\\f14c";
}
.icon-edit:before {
	content: "\\f14d";
}
.icon-ellipsis-vertical:before {
	content: "\\f14e";
}
.icon-empty:before {
	content: "\\f14f";
}
.icon-envelope:before {
	content: "\\f150";
}
.icon-exclamation-circle:before {
	content: "\\f151";
}
.icon-exclamation:before {
	content: "\\f152";
}
.icon-expand-all-lg:before {
	content: "\\f153";
}
.icon-expand-all:before {
	content: "\\f154";
}
.icon-expand-more-md:before {
	content: "\\f155";
}
.icon-expand:before {
	content: "\\f156";
}
.icon-external-link:before {
	content: "\\f157";
}
.icon-external:before {
	content: "\\f158";
}
.icon-eye-cosmos:before {
	content: "\\f159";
}
.icon-eye:before {
	content: "\\f15a";
}
.icon-file-alt-lg:before {
	content: "\\f15b";
}
.icon-file-alt:before {
	content: "\\f15c";
}
.icon-fill-color:before {
	content: "\\f15d";
}
.icon-grip-lines:before {
	content: "\\f15e";
}
.icon-group:before {
	content: "\\f15f";
}
.icon-home:before {
	content: "\\f160";
}
.icon-horn:before {
	content: "\\f161";
}
.icon-hot:before {
	content: "\\f162";
}
.icon-hourglass:before {
	content: "\\f163";
}
.icon-icon-content:before {
	content: "\\f164";
}
.icon-icon-quiz:before {
	content: "\\f165";
}
.icon-image:before {
	content: "\\f166";
}
.icon-import:before {
	content: "\\f167";
}
.icon-interrogation:before {
	content: "\\f168";
}
.icon-italic:before {
	content: "\\f169";
}
.icon-keys:before {
	content: "\\f16a";
}
.icon-light-bulb:before {
	content: "\\f16b";
}
.icon-lightbulb-on:before {
	content: "\\f16c";
}
.icon-list:before {
	content: "\\f16d";
}
.icon-loading:before {
	content: "\\f16e";
}
.icon-lock:before {
	content: "\\f16f";
}
.icon-menu:before {
	content: "\\f170";
}
.icon-next:before {
	content: "\\f171";
}
.icon-obj-align-center-default:before {
	content: "\\f172";
}
.icon-obj-align-center:before {
	content: "\\f173";
}
.icon-obj-align-left:before {
	content: "\\f174";
}
.icon-obj-align-right:before {
	content: "\\f175";
}
.icon-open-arrow:before {
	content: "\\f176";
}
.icon-order-bring-back:before {
	content: "\\f177";
}
.icon-order-bring-front:before {
	content: "\\f178";
}
.icon-order:before {
	content: "\\f179";
}
.icon-padlock:before {
	content: "\\f17a";
}
.icon-paper-plane:before {
	content: "\\f17b";
}
.icon-pen-to-square:before {
	content: "\\f17c";
}
.icon-photo:before {
	content: "\\f17d";
}
.icon-pizza-chart:before {
	content: "\\f17e";
}
.icon-play:before {
	content: "\\f17f";
}
.icon-plus:before {
	content: "\\f180";
}
.icon-processing:before {
	content: "\\f181";
}
.icon-publish-md:before {
	content: "\\f182";
}
.icon-publish:before {
	content: "\\f183";
}
.icon-question-square-lg:before {
	content: "\\f184";
}
.icon-question-square:before {
	content: "\\f185";
}
.icon-question:before {
	content: "\\f186";
}
.icon-quiz:before {
	content: "\\f187";
}
.icon-rating:before {
	content: "\\f188";
}
.icon-report:before {
	content: "\\f189";
}
.icon-reports:before {
	content: "\\f18a";
}
.icon-retry:before {
	content: "\\f18b";
}
.icon-right:before {
	content: "\\f18c";
}
.icon-round-check:before {
	content: "\\f18d";
}
.icon-rounded_check:before {
	content: "\\f18e";
}
.icon-rounded_error:before {
	content: "\\f18f";
}
.icon-sales-menu:before {
	content: "\\f190";
}
.icon-sales:before {
	content: "\\f191";
}
.icon-search:before {
	content: "\\f192";
}
.icon-shrink:before {
	content: "\\f193";
}
.icon-signal-stream-lg:before {
	content: "\\f194";
}
.icon-signal-stream:before {
	content: "\\f195";
}
.icon-spinner-third:before {
	content: "\\f196";
}
.icon-student:before {
	content: "\\f197";
}
.icon-subtitle-error:before {
	content: "\\f198";
}
.icon-subtitle:before {
	content: "\\f199";
}
.icon-translate:before {
	content: "\\f19a";
}
.icon-trash:before {
	content: "\\f19b";
}
.icon-triangle-up:before {
	content: "\\f19c";
}
.icon-underline:before {
	content: "\\f19d";
}
.icon-unlock:before {
	content: "\\f19e";
}
.icon-unpublish:before {
	content: "\\f19f";
}
.icon-upload-cosmos-md:before {
	content: "\\f1a0";
}
.icon-upload-cosmos:before {
	content: "\\f1a1";
}
.icon-upload-md:before {
	content: "\\f1a2";
}
.icon-upload:before {
	content: "\\f1a3";
}
.icon-upsell:before {
	content: "\\f1a4";
}
.icon-users-cosmos:before {
	content: "\\f1a5";
}
.icon-users-lg:before {
	content: "\\f1a6";
}
.icon-users:before {
	content: "\\f1a7";
}
.icon-video-player-border:before {
	content: "\\f1a8";
}
.icon-visualize:before {
	content: "\\f1a9";
}
.icon-visualize2:before {
	content: "\\f1aa";
}
`, "",{"version":3,"sources":["webpack://./src/components/svg/index.font.js"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,mBAAmB;CACnB;;;;oHAImH;AACpH;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB","sourcesContent":["@font-face {\n\tfont-family: \"icon\";\n\tfont-display: block;\n\tsrc: url(\"https://static.club.hotmart.com/admin/beta/fonts/icon.52890268f0375f7bd49ed6145a31fb1a.eot?#iefix\") format(\"embedded-opentype\"),\nurl(\"https://static.club.hotmart.com/admin/beta/fonts/icon.72d402e7d174df603e21770726d748f5.woff\") format(\"woff\"),\nurl(\"https://static.club.hotmart.com/admin/beta/fonts/icon.9009ded4b3d242c828d28efc5e39acb2.woff2\") format(\"woff2\"),\nurl(\"https://static.club.hotmart.com/admin/beta/fonts/icon.5a4def8981013a949ab33e709dd1ecf5.ttf\") format(\"truetype\"),\nurl(\"https://static.club.hotmart.com/admin/beta/fonts/icon.e687e3b49a1a9d8610127dedfeefd686.svg#icon\") format(\"svg\");\n}\n\n#ClubAdminApp .icon {\n\tline-height: 1;\n}\n\n#ClubAdminApp .icon:before {\n\tfont-family: icon !important;\n\tfont-style: normal;\n\tfont-weight: normal !important;\n\tvertical-align: top;\n}\n\n.icon-add-content:before {\n\tcontent: \"\\f101\";\n}\n.icon-add-quiz:before {\n\tcontent: \"\\f102\";\n}\n.icon-add-text:before {\n\tcontent: \"\\f103\";\n}\n.icon-add-upsell:before {\n\tcontent: \"\\f104\";\n}\n.icon-add:before {\n\tcontent: \"\\f105\";\n}\n.icon-alarm:before {\n\tcontent: \"\\f106\";\n}\n.icon-align-center:before {\n\tcontent: \"\\f107\";\n}\n.icon-align-justify:before {\n\tcontent: \"\\f108\";\n}\n.icon-align-left:before {\n\tcontent: \"\\f109\";\n}\n.icon-align-right:before {\n\tcontent: \"\\f10a\";\n}\n.icon-align:before {\n\tcontent: \"\\f10b\";\n}\n.icon-arrow-down:before {\n\tcontent: \"\\f10c\";\n}\n.icon-arrow-forward:before {\n\tcontent: \"\\f10d\";\n}\n.icon-arrow-left:before {\n\tcontent: \"\\f10e\";\n}\n.icon-arrow-link:before {\n\tcontent: \"\\f10f\";\n}\n.icon-arrow-path:before {\n\tcontent: \"\\f110\";\n}\n.icon-arrow-right:before {\n\tcontent: \"\\f111\";\n}\n.icon-arrow-up-down:before {\n\tcontent: \"\\f112\";\n}\n.icon-arrow-up-right:before {\n\tcontent: \"\\f113\";\n}\n.icon-arrow-up:before {\n\tcontent: \"\\f114\";\n}\n.icon-ask-icon:before {\n\tcontent: \"\\f115\";\n}\n.icon-back:before {\n\tcontent: \"\\f116\";\n}\n.icon-badge-dollar-lg:before {\n\tcontent: \"\\f117\";\n}\n.icon-badge-dollar:before {\n\tcontent: \"\\f118\";\n}\n.icon-bell-cosmos:before {\n\tcontent: \"\\f119\";\n}\n.icon-bell-lg:before {\n\tcontent: \"\\f11a\";\n}\n.icon-bell-md:before {\n\tcontent: \"\\f11b\";\n}\n.icon-bell:before {\n\tcontent: \"\\f11c\";\n}\n.icon-bold:before {\n\tcontent: \"\\f11d\";\n}\n.icon-calendar-plus:before {\n\tcontent: \"\\f11e\";\n}\n.icon-calendar:before {\n\tcontent: \"\\f11f\";\n}\n.icon-camera:before {\n\tcontent: \"\\f120\";\n}\n.icon-change:before {\n\tcontent: \"\\f121\";\n}\n.icon-chart:before {\n\tcontent: \"\\f122\";\n}\n.icon-chat:before {\n\tcontent: \"\\f123\";\n}\n.icon-check-cosmos:before {\n\tcontent: \"\\f124\";\n}\n.icon-check-green-cosmos:before {\n\tcontent: \"\\f125\";\n}\n.icon-check-green:before {\n\tcontent: \"\\f126\";\n}\n.icon-check-normal:before {\n\tcontent: \"\\f127\";\n}\n.icon-check-red-big:before {\n\tcontent: \"\\f128\";\n}\n.icon-check:before {\n\tcontent: \"\\f129\";\n}\n.icon-checkbox-check:before {\n\tcontent: \"\\f12a\";\n}\n.icon-chevron-down:before {\n\tcontent: \"\\f12b\";\n}\n.icon-chevron-up:before {\n\tcontent: \"\\f12c\";\n}\n.icon-class-arrow:before {\n\tcontent: \"\\f12d\";\n}\n.icon-class:before {\n\tcontent: \"\\f12e\";\n}\n.icon-classes:before {\n\tcontent: \"\\f12f\";\n}\n.icon-close-arrow:before {\n\tcontent: \"\\f130\";\n}\n.icon-close-circle:before {\n\tcontent: \"\\f131\";\n}\n.icon-close-cosmos:before {\n\tcontent: \"\\f132\";\n}\n.icon-close:before {\n\tcontent: \"\\f133\";\n}\n.icon-collapse-all-lg:before {\n\tcontent: \"\\f134\";\n}\n.icon-collapse-all:before {\n\tcontent: \"\\f135\";\n}\n.icon-color-picker:before {\n\tcontent: \"\\f136\";\n}\n.icon-combined-shape-back:before {\n\tcontent: \"\\f137\";\n}\n.icon-combined-shape-front:before {\n\tcontent: \"\\f138\";\n}\n.icon-combined-shape:before {\n\tcontent: \"\\f139\";\n}\n.icon-comments-inverted:before {\n\tcontent: \"\\f13a\";\n}\n.icon-comments:before {\n\tcontent: \"\\f13b\";\n}\n.icon-communicate:before {\n\tcontent: \"\\f13c\";\n}\n.icon-community-menu:before {\n\tcontent: \"\\f13d\";\n}\n.icon-community:before {\n\tcontent: \"\\f13e\";\n}\n.icon-configs:before {\n\tcontent: \"\\f13f\";\n}\n.icon-configuration:before {\n\tcontent: \"\\f140\";\n}\n.icon-content-list-empty-image:before {\n\tcontent: \"\\f141\";\n}\n.icon-content-menu:before {\n\tcontent: \"\\f142\";\n}\n.icon-content:before {\n\tcontent: \"\\f143\";\n}\n.icon-delete-lg:before {\n\tcontent: \"\\f144\";\n}\n.icon-delete:before {\n\tcontent: \"\\f145\";\n}\n.icon-down-chevron:before {\n\tcontent: \"\\f146\";\n}\n.icon-download:before {\n\tcontent: \"\\f147\";\n}\n.icon-duplicate-cosmos:before {\n\tcontent: \"\\f148\";\n}\n.icon-duplicate-lg:before {\n\tcontent: \"\\f149\";\n}\n.icon-duplicate-sm:before {\n\tcontent: \"\\f14a\";\n}\n.icon-duplicate:before {\n\tcontent: \"\\f14b\";\n}\n.icon-edit-cosmos:before {\n\tcontent: \"\\f14c\";\n}\n.icon-edit:before {\n\tcontent: \"\\f14d\";\n}\n.icon-ellipsis-vertical:before {\n\tcontent: \"\\f14e\";\n}\n.icon-empty:before {\n\tcontent: \"\\f14f\";\n}\n.icon-envelope:before {\n\tcontent: \"\\f150\";\n}\n.icon-exclamation-circle:before {\n\tcontent: \"\\f151\";\n}\n.icon-exclamation:before {\n\tcontent: \"\\f152\";\n}\n.icon-expand-all-lg:before {\n\tcontent: \"\\f153\";\n}\n.icon-expand-all:before {\n\tcontent: \"\\f154\";\n}\n.icon-expand-more-md:before {\n\tcontent: \"\\f155\";\n}\n.icon-expand:before {\n\tcontent: \"\\f156\";\n}\n.icon-external-link:before {\n\tcontent: \"\\f157\";\n}\n.icon-external:before {\n\tcontent: \"\\f158\";\n}\n.icon-eye-cosmos:before {\n\tcontent: \"\\f159\";\n}\n.icon-eye:before {\n\tcontent: \"\\f15a\";\n}\n.icon-file-alt-lg:before {\n\tcontent: \"\\f15b\";\n}\n.icon-file-alt:before {\n\tcontent: \"\\f15c\";\n}\n.icon-fill-color:before {\n\tcontent: \"\\f15d\";\n}\n.icon-grip-lines:before {\n\tcontent: \"\\f15e\";\n}\n.icon-group:before {\n\tcontent: \"\\f15f\";\n}\n.icon-home:before {\n\tcontent: \"\\f160\";\n}\n.icon-horn:before {\n\tcontent: \"\\f161\";\n}\n.icon-hot:before {\n\tcontent: \"\\f162\";\n}\n.icon-hourglass:before {\n\tcontent: \"\\f163\";\n}\n.icon-icon-content:before {\n\tcontent: \"\\f164\";\n}\n.icon-icon-quiz:before {\n\tcontent: \"\\f165\";\n}\n.icon-image:before {\n\tcontent: \"\\f166\";\n}\n.icon-import:before {\n\tcontent: \"\\f167\";\n}\n.icon-interrogation:before {\n\tcontent: \"\\f168\";\n}\n.icon-italic:before {\n\tcontent: \"\\f169\";\n}\n.icon-keys:before {\n\tcontent: \"\\f16a\";\n}\n.icon-light-bulb:before {\n\tcontent: \"\\f16b\";\n}\n.icon-lightbulb-on:before {\n\tcontent: \"\\f16c\";\n}\n.icon-list:before {\n\tcontent: \"\\f16d\";\n}\n.icon-loading:before {\n\tcontent: \"\\f16e\";\n}\n.icon-lock:before {\n\tcontent: \"\\f16f\";\n}\n.icon-menu:before {\n\tcontent: \"\\f170\";\n}\n.icon-next:before {\n\tcontent: \"\\f171\";\n}\n.icon-obj-align-center-default:before {\n\tcontent: \"\\f172\";\n}\n.icon-obj-align-center:before {\n\tcontent: \"\\f173\";\n}\n.icon-obj-align-left:before {\n\tcontent: \"\\f174\";\n}\n.icon-obj-align-right:before {\n\tcontent: \"\\f175\";\n}\n.icon-open-arrow:before {\n\tcontent: \"\\f176\";\n}\n.icon-order-bring-back:before {\n\tcontent: \"\\f177\";\n}\n.icon-order-bring-front:before {\n\tcontent: \"\\f178\";\n}\n.icon-order:before {\n\tcontent: \"\\f179\";\n}\n.icon-padlock:before {\n\tcontent: \"\\f17a\";\n}\n.icon-paper-plane:before {\n\tcontent: \"\\f17b\";\n}\n.icon-pen-to-square:before {\n\tcontent: \"\\f17c\";\n}\n.icon-photo:before {\n\tcontent: \"\\f17d\";\n}\n.icon-pizza-chart:before {\n\tcontent: \"\\f17e\";\n}\n.icon-play:before {\n\tcontent: \"\\f17f\";\n}\n.icon-plus:before {\n\tcontent: \"\\f180\";\n}\n.icon-processing:before {\n\tcontent: \"\\f181\";\n}\n.icon-publish-md:before {\n\tcontent: \"\\f182\";\n}\n.icon-publish:before {\n\tcontent: \"\\f183\";\n}\n.icon-question-square-lg:before {\n\tcontent: \"\\f184\";\n}\n.icon-question-square:before {\n\tcontent: \"\\f185\";\n}\n.icon-question:before {\n\tcontent: \"\\f186\";\n}\n.icon-quiz:before {\n\tcontent: \"\\f187\";\n}\n.icon-rating:before {\n\tcontent: \"\\f188\";\n}\n.icon-report:before {\n\tcontent: \"\\f189\";\n}\n.icon-reports:before {\n\tcontent: \"\\f18a\";\n}\n.icon-retry:before {\n\tcontent: \"\\f18b\";\n}\n.icon-right:before {\n\tcontent: \"\\f18c\";\n}\n.icon-round-check:before {\n\tcontent: \"\\f18d\";\n}\n.icon-rounded_check:before {\n\tcontent: \"\\f18e\";\n}\n.icon-rounded_error:before {\n\tcontent: \"\\f18f\";\n}\n.icon-sales-menu:before {\n\tcontent: \"\\f190\";\n}\n.icon-sales:before {\n\tcontent: \"\\f191\";\n}\n.icon-search:before {\n\tcontent: \"\\f192\";\n}\n.icon-shrink:before {\n\tcontent: \"\\f193\";\n}\n.icon-signal-stream-lg:before {\n\tcontent: \"\\f194\";\n}\n.icon-signal-stream:before {\n\tcontent: \"\\f195\";\n}\n.icon-spinner-third:before {\n\tcontent: \"\\f196\";\n}\n.icon-student:before {\n\tcontent: \"\\f197\";\n}\n.icon-subtitle-error:before {\n\tcontent: \"\\f198\";\n}\n.icon-subtitle:before {\n\tcontent: \"\\f199\";\n}\n.icon-translate:before {\n\tcontent: \"\\f19a\";\n}\n.icon-trash:before {\n\tcontent: \"\\f19b\";\n}\n.icon-triangle-up:before {\n\tcontent: \"\\f19c\";\n}\n.icon-underline:before {\n\tcontent: \"\\f19d\";\n}\n.icon-unlock:before {\n\tcontent: \"\\f19e\";\n}\n.icon-unpublish:before {\n\tcontent: \"\\f19f\";\n}\n.icon-upload-cosmos-md:before {\n\tcontent: \"\\f1a0\";\n}\n.icon-upload-cosmos:before {\n\tcontent: \"\\f1a1\";\n}\n.icon-upload-md:before {\n\tcontent: \"\\f1a2\";\n}\n.icon-upload:before {\n\tcontent: \"\\f1a3\";\n}\n.icon-upsell:before {\n\tcontent: \"\\f1a4\";\n}\n.icon-users-cosmos:before {\n\tcontent: \"\\f1a5\";\n}\n.icon-users-lg:before {\n\tcontent: \"\\f1a6\";\n}\n.icon-users:before {\n\tcontent: \"\\f1a7\";\n}\n.icon-video-player-border:before {\n\tcontent: \"\\f1a8\";\n}\n.icon-visualize:before {\n\tcontent: \"\\f1a9\";\n}\n.icon-visualize2:before {\n\tcontent: \"\\f1aa\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
